import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BaseSiteService, OccConfig, OccEndpointsService } from '@spartacus/core'
import { environment } from '../../environments/environment'
import { IAppConfig } from '../models/interface/app-config.interface'

@Injectable({
  providedIn: 'root'
})
export class AppConfigurationService {
  static settings: IAppConfig

  constructor(
    private readonly http: HttpClient,
    private baseSiteService: BaseSiteService,
    private occConfig: OccConfig,
    protected occEndpoints: OccEndpointsService,
  ) {}

  public async load(): Promise<void> {
    const jsonFile = `public/config/config.${environment.name}.json`
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(jsonFile)
        .toPromise()
        .then((response: IAppConfig) => {
          AppConfigurationService.settings = response
          resolve()
        })
        .catch((response: any) => {
          reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`)
        })
    })
  }

  public getRecaptchaSitekey(): string {
    return AppConfigurationService.settings.recaptcha.siteKey
  }

  public getBaseSiteUrl(): string {
    let baseSite: string
    this.baseSiteService.getActive().subscribe((activeBaseSite) => {
      baseSite = activeBaseSite
    })
    const baseUrl = this.occConfig.backend.occ.baseUrl
    const prefix = this.occConfig.backend.occ.prefix
    const baseSiteUrl = baseUrl + prefix + baseSite
    return baseSiteUrl
  }

  public getbaseUrl(): string {
    return this.occConfig.backend.occ.baseUrl.toString();
  }
}
